var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"Dashboard-View"},[_c('router-view'),_c('div',{staticClass:"clearfix"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }